module.exports = __webpack_public_path__ + "static/img/faq.aaef4555.png";